const EMPTY_DOMAIN = [0, 1] as const;
const MIN_PADDING = 0.02;

/** Recharts `auto` clips series containing null years; compute bounds and preserve recoveries below zero. */
export const lossRatioYDomain = (values: readonly (number | null)[]): readonly [number, number] => {
	const present = values.filter((value): value is number => value !== null);
	if (present.length === 0) return EMPTY_DOMAIN;

	const lowest = Math.min(...present);
	const highest = Math.max(...present);
	const pad = Math.max((highest - lowest) * 0.1, MIN_PADDING);
	return [lowest < 0 ? lowest - pad : 0, highest + pad];
};

export const trimEmptyYears = <T extends { selected: number | null; comparison: number | null }>(
	rows: readonly T[],
): T[] => {
	const first = rows.findIndex((row) => row.selected !== null || row.comparison !== null);
	if (first === -1) return [];

	let last = rows.length - 1;
	while (last > first && rows[last]?.selected === null && rows[last]?.comparison === null) {
		last -= 1;
	}
	return rows.slice(first, last + 1);
};
